import { Component, Input, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BankAccountControls } from '../edit-case-dialog.service';
import { LockBankAccountDialogComponent } from '../lock-bank-account-dialog/lock-bank-account-dialog.component';
import { UnlockBankAccountDialogComponent } from '../unlock-bank-account-dialog/unlock-bank-account-dialog.component';
import { PayeeIconButtonComponent } from '../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { PayeeFormFieldComponent } from '../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from '../../../shared/payee-input/payee-input.directive';

@Component({
  selector: 'app-bank-account-form',
  templateUrl: './bank-account-form.component.html',
  styleUrls: ['./bank-account-form.component.scss'],
  imports: [
    PayeeIconButtonComponent,
    PayeeIconComponent,
    PayeeFormFieldComponent,
    PayeeInputDirective,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class BankAccountFormComponent {
  private dialog = inject(MatDialog);

  @Input({ required: true }) form!: FormGroup<BankAccountControls>;

  get lock_bank_account() {
    return this.form.controls.lock_bank_account;
  }
  get account_number() {
    return this.form.controls.account_number;
  }
  get bic() {
    return this.form.controls.bic;
  }
  get bank_name() {
    return this.form.controls.bank_name;
  }

  openLockDialog(): void {
    this.dialog.open(LockBankAccountDialogComponent, {
      data: { bank_account: this.form },
    });
  }

  openUnlockDialog(): void {
    this.dialog.open(UnlockBankAccountDialogComponent, {
      data: { bank_account: this.form },
    });
  }
}
